const ModalContentReplacerEnums = {
    DEFAULT_CONTENT: 0,
    RECIPIENT_SEARCH_UI: 1,
    UPGRADE_RECURRING_UI: 2,
    EXIT_INTENT_UI: 3,
};

export default ModalContentReplacerEnums;
